module.exports = __webpack_public_path__ + "img/banner5.d7216ad6.jpg";